module.exports = __webpack_public_path__ + "static/media/19ESCAP27.4e317c92.jpg";